import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaEnvelope, FaMapMarkerAlt, FaTerminal } from 'react-icons/fa';
import { Link as ScrollLink } from 'react-scroll';
import profileImg from '../../assets/profile.png';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="hero">
      <div className="container hero__content">
        <motion.div
          className="hero__text"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          <div className="hero__status-badge">
            <span className="hero__status-dot" />
            <span>[ AVAILABLE FOR AI ENGINEER &amp; MLOPS ROLES ]</span>
          </div>

          <h1 className="hero__name">
            Sudip <span className="hero__name-accent">Majkoti</span>
          </h1>

          <div className="hero__title-row">
            <span className="hero__title-label">ROLE:</span>
            <h2 className="hero__title">AI Engineer</h2>
            <span className="hero__title-sep">/</span>
            <span className="hero__title-sub">Machine Learning &amp; Agents</span>
          </div>

          <p className="hero__desc">
            Specialized in architecting intelligent <strong>AI agents</strong>, <strong>RAG-based systems</strong>, and fine-tuned <strong>deep learning models</strong>. Experienced in designing scalable AI solutions, developing robust APIs, and shipping production-ready systems with Docker and MLOps pipelines.
          </p>

          <div className="hero__meta-strip">
            <div className="hero__meta-item">
              <FaMapMarkerAlt />
              <span>Nepal</span>
            </div>
            <span className="hero__meta-sep">&bull;</span>
            <div className="hero__meta-item">
              <FaTerminal />
              <span>Python &bull; LangGraph &bull; PyTorch &bull; FastAPI</span>
            </div>
          </div>

          <div className="hero__actions">
            <ScrollLink to="projects" smooth="easeOutCubic" duration={350} offset={-70} className="btn btn-primary">
              View Featured Projects
            </ScrollLink>
            <ScrollLink to="cv" smooth="easeOutCubic" duration={350} offset={-70} className="btn btn-outline">
              View &amp; Download CV
            </ScrollLink>
            <ScrollLink to="contact" smooth="easeOutCubic" duration={350} offset={-70} className="btn btn-outline">
              Get In Touch
            </ScrollLink>
          </div>

          <div className="hero__socials">
            <a
              href="https://github.com/sudipmajkoti07"
              target="_blank"
              rel="noreferrer"
              aria-label="GitHub"
              title="GitHub"
            >
              <FaGithub />
              <span>GitHub</span>
            </a>
            <a
              href="https://linkedin.com/in/sudipmajkoti"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
              title="LinkedIn"
            >
              <FaLinkedin />
              <span>LinkedIn</span>
            </a>
            <a
              href="mailto:sudipmazkoti@gmail.com"
              aria-label="Email"
              title="Email"
            >
              <FaEnvelope />
              <span>Email</span>
            </a>
          </div>
        </motion.div>

        <motion.div
          className="hero__visual"
          initial={{ opacity: 0, scale: 0.92 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.15, ease: 'easeOut' }}
        >
          <div className="hero__avatar-frame">
            <div className="hero__avatar-inner">
              <img src={profileImg} alt="Sudip Majkoti" className="hero__avatar-img" />
            </div>
            <div className="hero__avatar-caption">
              <span>SUDIP MAJKOTI</span>
              <span className="hero__caption-role">AI ENGINEER</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
